module.exports = __webpack_public_path__ + "static/media/30.804f46ef.svg";